import { RegistrationLayout } from "../Register";

export const PostCampaign = () => {
  return <RegistrationLayout postCampaign />;
};
